import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import { Popconfirm } from 'antd'
import { strVal } from '../../../../modules/Utils'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import PercentCell from '../../../../elements/Table/Cells/PercentCell'
import { AddQuoteContext } from './AddQuoteCont'

function QuoteLinesList() {
  const { type, quote, lines, fetchingLines, copyEnquiryLines, onShowLine, actions, fetchLines } = React.useContext(
    AddQuoteContext
  )

  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Line No',
      accessor: 'no',
      width: 100,
      Cell: ({ value, original }) => <a onClick={() => onShowLine(original, 'edit')}>{value || original.uuid}</a>,
    },
    {
      Header: 'Name',
      accessor: 'name',
      alignment: 'left',
      Cell: ({ value, original }) => (
        <a onClick={() => onShowLine(original, 'edit')}>{value || strVal(original, 'product.name')}</a>
      ),
    },
    {
      Header: 'Product',
      accessor: 'product.name',
      width: 350,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'SKU',
      accessor: 'productLine.name',
      width: 250,
      alignment: 'left',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Category',
      accessor: 'product.category.name',
      width: 150,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Group',
      accessor: 'product.group.name',
      width: 150,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Quantity',
      accessor: 'unit',
      width: 100,
      Cell: MoneyCell,
      Footer: SumFooter,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'UOM',
      accessor: 'uom.code',
      width: 100,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Sell Rate',
      accessor: 'rate',
      width: 100,
      Cell: MoneyCell,
    },
    {
      Header: 'Item Margin',
      accessor: 'buildUp.cost.margin',
      width: 100,
      Cell: PercentCell,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Total Buy',
      accessor: 'buildUp.total.subTotalCost',
      width: 100,
      Cell: MoneyCell,
      Footer: SumFooter,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Total Sell',
      accessor: 'amount.gross',
      width: 100,
      Cell: MoneyCell,
      Footer: SumFooter,
    },
    {
      Header: 'Total Margin',
      accessor: 'buildUp.total.subTotalMargin',
      width: 100,
      Cell: MoneyCell,
      Footer: SumFooter,
      hideable: true,
      hideDefault: false,
    },
    {
      Header: 'Item Cost',
      accessor: 'buildUp.cost.cost',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Item Fin Cost',
      accessor: 'buildUp.finance.cost',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Item Fin Sell',
      accessor: 'buildUp.finance.sell',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Item Other Cost',
      accessor: 'buildUp.other.cost',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Item Other Sell',
      accessor: 'buildUp.other.sell',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Total Finance Cost',
      accessor: 'buildUp.total.financeCost',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Total Other Cost',
      accessor: 'buildUp.total.otherCost',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Tax Type',
      accessor: 'tax.type',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Tax percentage',
      accessor: 'tax.percentage',
      width: 100,
      hideable: true,
      hideDefault: true,
    },
  ]

  const isUpdatable = type === 'new' || !!actions.find((a) => a.key === 'update')
  return (
    <CustomTable
      columns={columns}
      data={lines}
      loading={fetchingLines}
      fetch={fetchLines}
      hide={{ refresh: type === 'new', create: !isUpdatable }}
      CreateButton={() => (
        <Button type={'primary'} size={'small'} icon={'plus'} onClick={onShowLine}>
          Add Line
        </Button>
      )}
      ExtraButtons={() => (
        <Popconfirm
          title={`Are you sure to copy enquiry lines from ${strVal(quote, 'enquiry.code')}? `}
          onConfirm={copyEnquiryLines}>
          <Button type={'dashed'} size={'small'} icon={'copy'} style={{ marginLeft: 10 }}>
            Copy Enquiry lines
          </Button>
        </Popconfirm>
      )}
    />
  )
}

QuoteLinesList.propTypes = {}
QuoteLinesList.defaultProps = {}

export default QuoteLinesList
